import { Injectable } from '@angular/core';
import { HubConnection } from '@microsoft/signalr';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface FilaAtendimento {
  NomeUsuarioWpp: string,
  Telefone: string,
  PhoneNumberIdProd: string,
  IdChatEquipe: string,
  DataHora: Date,
  Status: string,
  UsuarioAtendente: string,
  idCliente: string,
  nomeCliente: string,
  mensagensNaoRespondidas: number
}

@Injectable({
  providedIn: 'root'
})
export class FilaAtendimentoManagerService {

  departamentoAtendimento = new BehaviorSubject<string>('');

  private contadores  = new Map<string, BehaviorSubject<number>>();

  idEquipeChat$ = this.departamentoAtendimento.asObservable();

  constructor() { }
  

    /** Retorna (ou cria) o contador do chat */
  getContador(chatId: string): BehaviorSubject<number> {
    if (!this.contadores.has(chatId)) {
      this.contadores.set(chatId, new BehaviorSubject<number>(0));
    }
    return this.contadores.get(chatId)!;
  }

  /** Atualiza o valor do contador vindo do backend */
  atualizarContador(chatId: string, valor: number) {
    const contador = this.getContador(chatId);
    contador.next(valor);
  }


  getTodos() {
    return this.contadores;
  }

  atualizarIdEquipeChat(equipe){
    this.departamentoAtendimento.next(equipe);
  }

  obterIdEquipeChatAtual() {
    return this.departamentoAtendimento.getValue();
  }

  //Este método é exclusivo para levar o cliente da fila geral para a fila do atendente ao iniciar o atendimento de um cliente.
  async trocarFilaGeral(hub: HubConnection, idUserChat: string, IdEquipeGeral: string, novaEquipeId: string) {
      let hubFila: HubConnection = hub;
      return hubFila.send("SetAlteraFilaAtendimento", idUserChat,
        IdEquipeGeral,
        novaEquipeId)
    }
}
